import { API } from "@/main.js";

const state = {
  activityDate: null
};

const getters = {};

const mutations = {
  /**
   * sets date of activity on store to use in tasks component (taskdetailsform does not have access to activity information)
   * a way to avoid creating a request or passing props.
   */
  SET_DATE(state, date) {
    state.activityDate = date;
  }
};

const actions = {
  /**
   * commits activity date to the store
   */
  saveActivity({ commit }, date) {
    commit("SET_DATE", date);
  },

  fetchAllActivities({ commit }, { params = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getAllActivities(
        params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchObjectActivities({ commit }, { filters = null, append = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getObjectActivities(
        filters,
        append,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  fetchMyActivities({ commit }, { filters = null, append = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getMyActivities(
        filters,
        append,

        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        },
        0
      );
    });
  },

  fetchActivity({ commit }, { activityUUID, includes = null, append = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getActivityByUUID(
        activityUUID,
        includes,
        append,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addActivity({ commit }, newActivityData) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createActivity(
        newActivityData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateActivity({ commit }, { activityUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateActivity(
        activityUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteActivity({ commit }, activityUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.deleteActivity(
        activityUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getPriorityList({ commit }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getPriorityList(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTasksByActivityUuid({ commit }, { uuid, params = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getTasksByActivityUuid(
        uuid,
        params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTask({ commit }, { taskUUID, includes = null }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getTaskByUUID(
        taskUUID,
        includes,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addTask({ commit }, { activityUUID, newTaskData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createTask(
        activityUUID,
        newTaskData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateTask({ commit }, { taskUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateTask(
        taskUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createTaskContent({ commit }, { taskUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createTaskContent(
        taskUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  updateTaskContent({ commit }, { taskUUID, contentUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateTaskContent(
        taskUUID,
        contentUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteTaskContent({ commit }, { taskUUID, contentUUID }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.deleteTaskContent(
        taskUUID,
        contentUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  unblockTask({ commit }, { taskUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.unblockTask(
        taskUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteTask({ commit }, { taskUUID }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.deleteTask(
        taskUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  approveActivityTask({ commit }, taskUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.approveTask(
        taskUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  rejectActivityTask({ commit }, { taskUUID, rejectionObject }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.rejectTask(
        taskUUID,
        rejectionObject,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchStepsByTaskUUID({ commit }, { uuid, params }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getStepsByTaskUuid(
        uuid,
        params,
        result => {
          resolve(result.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },


  /////////////////////////////////////////////////////////// ACTIVITY TEMPLATES \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  fetchActivityTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getAllActivityTemplates(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchActivityTemplateByUUID({ commit }, activityUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getActivityTemplateByUUID(
        activityUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addActivityTemplate({ commit }, activityTemplateData) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createActivityTemplate(
        activityTemplateData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteActivityTemplate({ commit }, activityUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.removeActivityTemplate(
        activityUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateActivityTemplate({ commit }, { activityUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateActivityTemplate(
        activityUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  ///////////////////////////////////////////////////////// TASK TEMPLATES \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  fetchTaskTemplates({ commit }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getAllTaskTemplates(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchTaskTemplateByUUID({ commit }, taskUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getTaskTemplateByUUID(
        taskUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addTaskTemplate({ commit }, taskTemplateData) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createTaskTemplate(
        taskTemplateData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteTaskTemplate({ commit }, taskUUID) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.removeTaskTemplate(
        taskUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  updateTaskTemplate({ commit }, { taskUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateTaskTemplate(
        taskUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getTaskTemplateContent({ commit }, { taskUUID }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.getTaskTemplateContent(
        taskUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  createTaskTemplateContent({ commit }, { taskUUID, updatedData }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.createTaskTemplateContent(
        taskUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  updateTaskTemplateContent(
    { commit },
    { taskUUID, contentUUID, updatedData }
  ) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.updateTaskTemplateContent(
        taskUUID,
        contentUUID,
        updatedData,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  deleteTaskTemplateContent({ commit }, { taskUUID, contentUUID }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.deleteTaskTemplateContent(
        taskUUID,
        contentUUID,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  exportWorkorder({ commit }, { uuid }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.exportWorkorder(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  exportActivity({ commit }, { uuid }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.exportActivity(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  exportTask({ commit }, { uuid }) {
    return new Promise((resolve, reject) => {
      API.activitiesAndTasks.exportTask(
        uuid,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/activities.js